import { createSlice } from "@reduxjs/toolkit";
import { defaultAddReducer, defaultSetReducer, defaultUpdateReducer, defaultRemoveReducer } from "./defaultReducer";

const initialState = {
  pdfData: null,
  year: null,
};

const slice = createSlice({
  name: "responsives",
  initialState,
  reducers: {
    setResponsivesDataReducer(state, action) {
      state.pdfData = {
        admin: action.payload.admin,
        regular: action.payload.regular,
      };
      state.year = action.payload.year;
    },
  },
});

// `createSlice` automatically generated action creators with these names.
// export them as named exports from this "slice" file
export const { setResponsivesDataReducer } = slice.actions;

// Export the slice reducer as the default export
export default slice.reducer;
